import { videoViewsRateConfig } from '@/lib/analytics/kpis/instagram/videoViewsRate';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const videoViewsRateMVConfig = {
    ...videoViewsRateConfig,
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
